import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ALL_NAV_ITEMS } from "@/lib/navigation";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator,
} from "@/components/ui/command";
import { NAV_GROUPS } from "@/lib/navigation";

export function CommandPalette() {
  const { paletteOpen, setPaletteOpen } = useApp();
  const navigate = useNavigate();

  const go = (path) => {
    setPaletteOpen(false);
    navigate(path);
  };

  return (
    <CommandDialog open={paletteOpen} onOpenChange={setPaletteOpen}>
      <span className="sr-only" role="heading" aria-level="1">Command palette</span>
      <CommandInput placeholder="Search modules, jump to anything…" data-testid="command-input" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        {NAV_GROUPS.map((group) => (
          <CommandGroup key={group.label} heading={group.label}>
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <CommandItem key={item.key} value={item.label} onSelect={() => go(item.path)} data-testid={`palette-${item.key}`}>
                  <Icon size={18} weight="duotone" className="mr-2" />
                  {item.label}
                </CommandItem>
              );
            })}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
